
import { EventBus, TypeEventBus } from '../../utils';
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      dialog: false,
      title: '',
      message: '',
      resolve: null as null | ((confirmed: boolean) => void),
    };
  },
  created() {
    EventBus.$on(TypeEventBus.CONFIRM_DIALOG, this.openDialog);
  },
  methods: {
    openDialog({
      title,
      message,
      resolve,
    }: {
      title: string;
      message: string;
      resolve: (confirmed: boolean) => void;
    }) {
      this.title = title;
      this.message = message;
      this.resolve = resolve;
      this.dialog = true;
    },
    confirm() {
      this.dialog = false;
      if(this.resolve){
        this.resolve(true)
      }
    },
    cancel() {
      this.dialog = false;
      if(this.resolve){
        this.resolve(false)
      }
    },
  },
});
